import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { siteWide } from '@helpers/grid';
import scrollbars from '@helpers/scrollbars';
import styled from 'styled-components';
const Container = styled.form `
  position: absolute;
  top: calc(100% - var(--headerNavHeight));
  left: 0;
  background: ${brand.primary.blueGrey};
  padding: 15px 0;
  width: 100%;
  z-index: 1;

  &[data-active='false'] {
    display: none;
  }

  &[data-active='true'] {
    display: block;
  }
`;
const SiteWide = styled.div `
  ${siteWide}
`;
const Inner = styled.div `
  position: relative;
`;
const InputWrapper = styled.div `
  position: relative;
  z-index: 1;
`;
const Input = styled.input `
  ${transition('border-color')}

  display: block;
  appearance: none;
  border: 2px solid rgba(0, 0, 0, 0.25);
  border-radius: 25px;
  color: ${brand.primary.blue};
  ${fonts.apparat.light}
  font-size: 18px;
  height: 50px;
  line-height: 1em;
  padding: 0 24px;
  width: 100%;

  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
  }

  &:focus {
    border-color: ${brand.primary.blue};
  }
`;
const Button = styled.button `
  ${transition('background-color, border-color, color')}

  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  display: inline-flex;
  align-items: center;
  background-color: ${brand.white};
  border: 2px solid ${brand.primary.blue};
  border-radius: 25px;
  color: ${brand.primary.blue};
  gap: 8px;
  padding: 0px ${fluid(20, 32)};

  ${Input}:focus + &,
  &:focus,
  &:hover {
    background-color: ${brand.primary.blue};
    border-color: ${brand.primary.blue};
    color: ${brand.white};
  }
`;
const ButtonIcon = styled.span `
  display: inline-block;
  height: 19px;
  transform: translateX(4px);
  width: 19px;

  ${Input}:focus + ${Button} &,
  ${Button}:focus &,
  ${Button}:hover & {
    transform: translateX(0px);
  }
`;
const ButtonLabel = styled.span `
  ${transition('width')}

  display: inline-block;
  color: currentColor;
  ${fonts.apparat.bold};
  font-size: 16px;
  line-height: 1em;
  overflow: hidden;
  text-decoration: none;
  text-transform: uppercase;
  white-space: nowrap;
  width: 0px;

  ${Input}:focus + ${Button} &,
  ${Button}:focus &,
  ${Button}:hover & {
    width: 6ch;
  }
`;
const SuggestionWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: block;
  background: ${brand.white};
  border: 2px solid rgba(0, 0, 0, 0.25);
  border-radius: 25px;
  padding: 82px 24px 32px;
  z-index: 0;
`;
const SuggestionList = styled.ul `
  ${scrollbars}

  --itemSpacing: 24px;
  --itemHeight: 40px;
  --maxVisible: 3;

  /* prettier-ignore */
  --maxHeight: calc(var(--itemSpacing) * (var(--maxVisible) - 1) + var(--itemHeight) * (var(--maxVisible)));

  display: flex;
  flex-direction: column;
  gap: var(--itemSpacing);
  max-height: var(--maxHeight);
  overflow-y: auto;
`;
const Suggestion = styled.li `
  display: block;
`;
const SuggestionLink = styled.a `
  display: flex;
  color: ${brand.primary.blue};
  flex-direction: column;
  height: var(--itemHeight);
  justify-content: center;
  row-gap: 8px;
  text-decoration: none;
  white-space: nowrap;
`;
const SuggestionTitle = styled.span `
  display: block;
  ${fonts.apparat.medium};
  font-size: 18px;
  line-height: 1em;

  ${SuggestionLink}:focus &,
  ${SuggestionLink}:hover & {
    text-decoration: underline;
  }
`;
const SuggestionSubtitle = styled.span `
  display: block;
  ${fonts.apparat.light};
  font-size: 14px;
  line-height: 1em;
  opacity: 0.25;
  order: -1;
  text-transform: uppercase;
`;
const MobileSearchStyles = {
    Button,
    ButtonIcon,
    ButtonLabel,
    Container,
    Inner,
    Input,
    InputWrapper,
    SiteWide,
    Suggestion,
    SuggestionLink,
    SuggestionList,
    SuggestionSubtitle,
    SuggestionTitle,
    SuggestionWrapper,
};
export default MobileSearchStyles;
